import { LabelsConfiguration } from '~/core/configuration/configuration-global-config.type';

export const getLabelType = (
    configuration: LabelsConfiguration | undefined,
    item: string,
    fallbackKey?: string
): string | undefined => {
    if (undefined === configuration) {
        return undefined;
    }

    const type = Object.keys(configuration).find((key) => {
        return configuration[key].some((label) => {
            if (label === '') {
                return false;
            }

            if (typeof item === 'number') {
                return false;
            }

            return item.includes(label);
        });
    });

    if (type) {
        return type;
    }

    if (fallbackKey && fallbackKey in configuration) {
        return fallbackKey;
    }

    return undefined;
};
